<template>
  <div>
    <el-menu router :default-active="shopRouter">
      <!-- <el-menu-item index="/system/home">
        <i class="el-icon-s-home"></i>
        <span slot="title">首页</span>
      </el-menu-item> -->

      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-money"></i>
          <span>后台管理</span>
        </template>
        <el-menu-item-group>

          <el-menu-item index="/order">填写列表</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>

<!-- <el-menu-item index="/order/msg">留言列表</el-menu-item> -->
</el-menu-item-group>
      </el-submenu>

      

      <!-- <el-submenu index="3">
        <template slot="title">
          <i class="el-icon-goods"></i>
          <span>商品管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/shop/good">产品管理</el-menu-item>
       
          
        </el-menu-item-group>
      </el-submenu> -->

      <!-- <el-submenu index="4" v-if="admin.is_admin==2">
        <template slot="title">
          <i class="el-icon-user"></i>
          <span>用户管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/user/index">用户列表</el-menu-item>
        </el-menu-item-group>
      </el-submenu> -->

     

     

      <el-submenu index="7"  >
        <template slot="title">
          <i class="el-icon-setting
"></i>
          <span>系统管理</span>
        </template>
        <el-menu-item-group>
          <!-- <el-menu-item index="/system/role">角色管理</el-menu-item> -->
          <el-menu-item index="/account">账号管理</el-menu-item>
       
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "asideBar",
  data() {
    return {
      shopRouter: "",
      adminRouter: "",
      admin_type: 1,
      admin: {},
    };
  },
  mounted() {
    this.routeChange(this.$route); //刷新后，在mounted时，取到路由对象
    this.admin = JSON.parse(localStorage.getItem("admin"));
    console.log(this.admin)
  },
  methods: {
    routeChange(route) {
      let shopPath = route.path;
      this.shopRouter = shopPath;
    },
  },
  watch: {
    $route(route) {
      //route==一路由信息对象
      this.routeChange(route);
    },
  },
};
</script>

<style scoped>

</style>
